
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"weekNumber"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekNumber"},"arguments":[],"directives":[]}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"analiseTopSellingProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SalesAnalyticsInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analiseTopSellingProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"store_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"store_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stddev"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"min_sale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"max_sale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total_sale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_plu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_description"},"arguments":[],"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"analiseTopSellingCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SalesAnalyticsInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analiseTopSellingCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"store_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"store_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stddev"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"min_sale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"max_sale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total_sale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category_name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":517}};
    doc.loc.source = {"body":"query weekNumber {\n  weekNumber\n}\n\nquery analiseTopSellingProducts($input: SalesAnalyticsInput) {\n  analiseTopSellingProducts(input: $input) {\n    store_id\n    store_name\n    stddev\n    min_sale\n    max_sale\n    total_sale\n    product_id\n    product_plu\n    product_description\n  }\n}\n\nquery analiseTopSellingCategories($input: SalesAnalyticsInput) {\n  analiseTopSellingCategories(input: $input) {\n    store_id\n    store_name\n    stddev\n    min_sale\n    max_sale\n    total_sale\n    category_id\n    category_name\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["weekNumber"] = oneQuery(doc, "weekNumber");
        
        module.exports["analiseTopSellingProducts"] = oneQuery(doc, "analiseTopSellingProducts");
        
        module.exports["analiseTopSellingCategories"] = oneQuery(doc, "analiseTopSellingCategories");
        
